import type { FC } from 'react';
import { MDText } from 'i18n-react';

import { numberWithCommas } from 'Utilities/helpers';

import LocalTexts from '../ServiceHistoryEnhancedSection.texts.json';

import styles from './ServiceHistoryGap.module.scss';

const LocalT = new MDText(LocalTexts);

export type ServiceHistoryGapsProps = {
	distance: Nullable<number>;
	months: Nullable<number>;
};

export const ServiceHistoryGap: FC<ServiceHistoryGapsProps> = ({ distance, months }) => {
	const formattedMileage = LocalT.translate('record.serviceGap.formattedMileage', {
		mileage: distance ? numberWithCommas(distance) : LocalT.translate('unknown'),
		pluralise: distance !== 1 ? 's' : '',
	});

	const formattedMonth = LocalT.translate('record.serviceGap.formattedMonth', {
		month: months || LocalT.translate('unknown'),
		pluralise: months !== 1 ? 's' : '',
	});

	const formattedServiceGap = LocalT.translate('record.serviceGap.formattedGap', { formattedMileage, formattedMonth });

	return <div className={styles.gap}>{formattedServiceGap}</div>;
};
